import React, { useState } from 'react';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import StylishNewInput from 'components/DesignSystems/New/StylishNewInput';
import { useCreateWorkAssignment } from '../../../hooks/workAssignmentHooks';
import PratusSelect, {
  OptionType,
} from 'components/DesignSystems/New/PratusSelect';
import { Row } from 'react-bootstrap';
import StylishDateTimePicker from 'components/DesignSystems/form/StylishDateTimePicker';
import { WorkAssignmentResources } from './WorkAssignmentResources';
import { useCurrentPeriod } from 'components/IAP/hooks/incidentHooks';

type AddWorkAssignmentCardProps = {
  setAdding: (adding: boolean) => void;
  workGroups: { id: string; name: string }[];
  resourceOptions: { label: string; value: string }[];
  selectedTactics: string[];
};

export const AddWorkAssignmentCard = ({
  setAdding,
  workGroups,
  resourceOptions,
  selectedTactics,
}: AddWorkAssignmentCardProps) => {
  const [name, setName] = useState('');
  const [resources, setResources] = useState<
    { label: string; value: string }[]
  >([]);
  const [overheadPosition, setOverheadPosition] = useState('');
  const [specialEquipment, setSpecialEquipment] = useState('');
  const [reportingLocation, setReportingLocation] = useState('');
  const [requestArrivalTime, setRequestArrivalTime] = useState<Date | null>(
    new Date()
  );
  const [selectedWorkGroup, setSelectedWorkGroup] = useState<string>('');
  const createWorkAssignment = useCreateWorkAssignment();

  const operationalPeriod = useCurrentPeriod();

  const periodNumber = operationalPeriod?.currentPeriod?.period_number || 0;

  const handleAdd = async () => {
    await createWorkAssignment.mutateAsync({
      work_assignment: name,
      status: 'Planned',
      parent_tactics: selectedTactics,
      work_group_id: selectedWorkGroup || undefined,
      resources,
      overhead_positions: overheadPosition,
      special_instructions: specialEquipment,
      reporting_location: reportingLocation,
      requested_arrival_time: requestArrivalTime || undefined,
      operational_period_number: periodNumber + 1,
    });
    setAdding(false);
  };
  return (
    <div className="bordered-card rounded m-0 mb-2">
      <Row>
        <div className="col">
          <label htmlFor="work-assignment-name">Work Assignment Name *</label>
          <StylishNewInput
            id="work-assignment-name"
            placeholder="Name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={255}
          />
        </div>
      </Row>
      <Row>
        <div className="col mt-2">
          <PratusSelect
            label="Work Group *"
            options={workGroups.map((group) => ({
              label: group.name,
              value: group.id,
            }))}
            value={{
              label: selectedWorkGroup
                ? workGroups.find((g) => g.id === selectedWorkGroup)?.name || ''
                : '',
              value: selectedWorkGroup || '',
            }}
            onChange={(newValue) => {
              setSelectedWorkGroup(
                (newValue as OptionType | null)?.value as string
              );
            }}
          />
        </div>
      </Row>
      <WorkAssignmentResources
        resourceOptions={resourceOptions}
        resourceList={resources}
        handleSave={(newResource: { label: string; value: string }) => {
          setResources((prev) => [...prev, newResource]);
        }}
      />
      <Row>
        <div className="col mt-2">
          <label htmlFor="op">Overhead Position</label>
          <StylishNewInput
            id="op"
            placeholder="Overhead Position"
            type="text"
            value={overheadPosition}
            onChange={(e) => setOverheadPosition(e.target.value)}
            maxLength={255}
          />
        </div>
      </Row>
      <Row>
        <div className="col mt-2">
          <label htmlFor="special-equipment">
            Special Equipment & Supplies
          </label>
          <StylishNewInput
            id="special-equipment"
            placeholder="Special Equipment & Supplies"
            type="text"
            value={specialEquipment}
            onChange={(e) => setSpecialEquipment(e.target.value)}
            maxLength={255}
          />
        </div>
      </Row>
      <Row>
        <div className="col mt-2">
          <label htmlFor="reporting-location">Reporting Location</label>
          <StylishNewInput
            id="reporting-location"
            placeholder="Reporting Location"
            type="text"
            value={reportingLocation}
            onChange={(e) => setReportingLocation(e.target.value)}
            maxLength={255}
          />
        </div>
      </Row>
      <Row>
        <div className="col mt-2">
          <StylishDateTimePicker
            value={requestArrivalTime}
            onChange={(e) => setRequestArrivalTime(e)}
            type={'datetime-local'}
            dateLabel="Request Arrival Date"
            timeZone
            timeZoneLabel
          />
        </div>
      </Row>
      <StylishNewButton onClick={handleAdd} className="mt-2 me-2">
        Add
      </StylishNewButton>
      <StylishNewButton
        className="button--secondary mt-2"
        onClick={() => {
          setName('');
          setAdding(false);
        }}
      >
        Cancel
      </StylishNewButton>
    </div>
  );
};
